export default "__VITE_ASSET__DWEq7Lsv__"